<template>
  <main v-if="webform">
    <PageHeader :title="webform.label" :subtitle />
    <section class="section">
      <Webform
        :webform
        class="container"
        :source-entity-id
        :source-entity-type
      />
    </section>
  </main>
</template>

<script setup lang="ts">
const { entity: webform } = await useDrupalRouteQuery('webform')

const subtitle = computed(() => webform.value.form.sourceEntity?.label)

const sourceEntityId = useQueryString('source_entity_id')
const sourceEntityType = useQueryString('source_entity_type')

await renderPageDependencies()
</script>
